<mat-card>
  <mat-card-content>
    <mat-card-title>
      Richiesta di adesione al Gii
    </mat-card-title>
  </mat-card-content>
</mat-card>

<mat-card>
  <mat-card-content>

    <div fxLayout="row wrap">
      <div fxFlex="100%;" fxFlex.xs="100%">
        Tipo di richiesta di adesione
        <strong>{{objiscrizione?.DescrizioneTipologiaRichiesta}}</strong> - <strong>{{objiscrizione?.DescrizioneTipoAdesione}}</strong>
      </div>
    </div>

    <p>Periodo <strong>{{objiscrizione?.Periodo}}</strong></p>

    <fieldset>
      <legend>Socio collettivo</legend>
      <p><strong>Ateneo/Istituto di ricerca</strong> {{objdettaglio?.Ateneo}}</p>

      <p><strong>Dipartimento</strong> {{objdettaglio?.Dipartimento}}</p>
    </fieldset>

    <fieldset>
      <legend>Referente</legend>
      <p><strong>Cognome e Nome</strong> {{objdettaglio?.Cognome}} {{objdettaglio?.Nome}}</p>

      <p><strong>Codice Fiscale</strong> {{objdettaglio?.CodiceFiscale}}</p>

      <p><strong>E-mail</strong> {{objdettaglio?.Email}}</p>
    </fieldset>

    <mat-card *ngIf="isEditTabella">
      <mat-card-content>

        <ngx-datatable #grd
                       [rows]="lstElencoNominativi"
                       [columnMode]="'flex'"
                       [headerHeight]="50"
                       [footerHeight]="50"
                       [limit]="30"
                       [rowHeight]="'auto'">

          <ngx-datatable-column name="Nome"
                                [flexGrow]="1"
                                [sortable]="true"
                                prop="Nome">
            <ng-template let-row="row" ngx-datatable-cell-template>
              {{ row?.Nome }}
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column name="Cognome"
                                [flexGrow]="1"
                                [sortable]="true"
                                prop="Cognome">
            <ng-template let-row="row" ngx-datatable-cell-template>
              {{ row?.Cognome }}
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column name="Email"
                                [flexGrow]="1"
                                [sortable]="true"
                                prop="Email">
            <ng-template let-row="row" ngx-datatable-cell-template>
              {{ row?.Email }}
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column name="Fascia"
                                [flexGrow]="1"
                                [sortable]="true"
                                prop="Fascia">
            <ng-template let-row="row" ngx-datatable-cell-template>
              {{ row?.Fascia }}
            </ng-template>
          </ngx-datatable-column>


          <ngx-datatable-column name="Codice Fiscale"
                                [flexGrow]="1"
                                [sortable]="true"
                                prop="CodiceFiscale">
            <ng-template let-row="row" ngx-datatable-cell-template>
              {{ row?.CodiceFiscale }}
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column name="Settore Scientifico"
                                [flexGrow]="1"
                                [sortable]="true"
                                prop="SettoreScientificoDescrizione">
            <ng-template let-row="row" ngx-datatable-cell-template>
              {{ row?.SettoreScientificoDescrizione }}
            </ng-template>
          </ngx-datatable-column>

        </ngx-datatable>

      </mat-card-content>
    </mat-card>



    <br />
    <!-- <div style="width:100%; text-align:center;">
     Importo da pagare * 25,00 €<br />
     prova {{objcalcolo}},00 €
   </div>-->
  <div style="width:100%; text-align:center;">
    Importo da pagare * {{objcalcolo}},00 €
  </div>
    <br />
    <mat-hint>* i dettagli per il pagamento saranno visualizzati dopo aver confermato la richiesta di adesione</mat-hint>
    <br /><br />
          <div mat-dialog-actions>
            <button mat-raised-button color="primary"
                    (click)="btnAnnulla()">
              Indietro
            </button>

            <br /><br />
            <button mat-raised-button color="primary"
                    (click)="btnConfermaRichiestaAdesione()"
                    cdkFocusInitial>
              Conferma Richiesta Adesione
            </button>
          </div>
  </mat-card-content>
</mat-card>


